import React from 'react';
import { OnwardLink } from '@/styles/blocks';
import { buildBillcomBillUrl } from '@/utilities/billcom';

// Renders an invoice's Bill.com bill id as a link to the bill in the BILL web app, mirroring
// NetsuiteLink: '--' when the invoice hasn't been pushed. Bill.com is payables-only, so a receivable
// always reads '--'. stopPropagation keeps clicks off any surrounding clickable row.
export const BillcomLink = ({ invoice }) => {
    const url = buildBillcomBillUrl(invoice);
    if (!url) return '--';

    return (
        <OnwardLink href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
            {invoice.billcom_bill_id}
        </OnwardLink>
    );
};
